import React from "react";
import type { EmailTemplateListItem } from "@/service/emailTemplate.service";

interface TemplateTableProps {
  templates: EmailTemplateListItem[];
  onView: (template: EmailTemplateListItem) => void;
  onEdit: (template: EmailTemplateListItem) => void;
}

const TemplateTable: React.FC<TemplateTableProps> = ({
  templates,
  onView,
  onEdit,
}) => {
  return (
    <div className="bg-white rounded-lg">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-[#F4F7F9] text-left">
          <tr>
            <th className="p-3 text-sm font-[600] text-[#1E1E1E]">
              Templates
            </th>
            <th className="p-3 text-sm font-[600] text-[#1E1E1E]">
              Last modified
            </th>
            <th className="p-3 text-sm font-[600] text-[#1E1E1E]">
              Status
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {templates.map((tpl) => (
            <tr key={tpl.id} className="hover:bg-[#F9FEFF]">
              <td className="px-3 py-3 text-sm text-[#1E1E1E] font-[500]">
                {tpl.name}
              </td>
              <td className="px-3 py-3 text-sm text-[#4B5563]">
                {tpl.last_updated}
              </td>
              <td className="px-3 py-3 text-sm text-[#4B5563]">
                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    className="text-[#4B5563] hover:text-[#111827] cursor-pointer"
                    onClick={() => onView(tpl)}
                  >
                    👁
                  </button>
                  <button
                    type="button"
                    className="text-[#4B5563] hover:text-[#111827] cursor-pointer"
                    onClick={() => onEdit(tpl)}
                  >
                    ✏️
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TemplateTable;
